import { render, staticRenderFns } from "./processDegreeDamage.vue?vue&type=template&id=48a2c244"
import script from "./processDegreeDamage.vue?vue&type=script&lang=js"
export * from "./processDegreeDamage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a2c244')) {
      api.createRecord('48a2c244', component.options)
    } else {
      api.reload('48a2c244', component.options)
    }
    module.hot.accept("./processDegreeDamage.vue?vue&type=template&id=48a2c244", function () {
      api.rerender('48a2c244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/reg/processDegreeDamage.vue"
export default component.exports